let lastWidth = -1;

var _learnq = _learnq || [];

$(document).ready(function () {
    const openMini = localStorage.getItem("open_mini");
    if (openMini === "1") {
        $("#cart-drawer").toggleClass("active");
        $("#mini-cart-overlay").toggleClass("active");
        $("#cart-drawer").css("z-index", 9999);
        // localStorage.setItem("open_mini", "0")
    }

    if (window.location.pathname.includes("/cart")) {
        var selectors = {
            body: "body",
            sitenav: "#siteNav",
            navLinks: "#siteNav .lvl1 > a",
            mobilenav: ".mobile-nav-wrapper",
            menuLinks: "#MobileNav .ad",
        };
        $(".js-mobile-nav-toggle, .closemobileMenu").on(
            "click",
            function (event) {
                body: "body", $(selectors.mobilenav).toggleClass("active");
                $(selectors.body).toggleClass("menuOn");
                $(".js-mobile-nav-toggle").toggleClass("open close");
            },
        );

        $("body").click(function (event) {
            var $target = $(event.target);
            if (
                !$target.parents().is(selectors.mobilenav) &&
                !$target.parents().is(".js-mobile-nav-toggle") &&
                !$target.is(".js-mobile-nav-toggle")
            ) {
                $(selectors.mobilenav).removeClass("active");
                $(selectors.body).removeClass("menuOn");
                $(".js-mobile-nav-toggle")
                    .removeClass("close")
                    .addClass("open");
            }
            // Hide cart drawer
            if (
                !$target.parents().is("#cart-drawer") &&
                !$target.is("#cart-drawer") &&
                !$target.parents().is(".header-cart") &&
                !$target.is(".header-cart")
            ) {
                $("#cart-drawer").removeClass("active");
            }
            // Hide settingsBox on document click
            if (
                !$target.parents().is("#settingsBox") &&
                !$target.parents().is(".site-settings") &&
                !$target.is(".site-settings")
            ) {
                $("#settingsBox").removeClass("active");
            }
        });

        $(selectors.menuLinks).on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).toggleClass("ad-plus-l ad-minus-l");
            $(this).parent().next().slideToggle();
        });
    }

    if (typeof preLoader !== "undefined") preLoader.start();

    if (typeof pSteps !== "undefined") {
        localStorage.setItem("product_original", JSON.stringify(pSteps));
        obj = JSON.stringify(pSteps);
    }

    $("#customize-old").click(function (e) {
        //e.preventDefault();
        //e.stopPropagation();
        console.error("customize");
        let imageUrl = "";
        if ($(window).innerWidth() >= 767) {
            imgUrl = $($(".product-single__photo img").get(0)).attr("src");
        } else {
            //mobile - a primeira div do slider não serve
            imgUrl = $($(".product-single__photo img").get(1)).attr("src");
        }

        nameOfShoe = $(".shoe-name").val();
        let product = window.datalayerCurrentProduct;
        product.name = nameOfShoe;
        // Alert("teste");
        $.post("https://3d.diverge-sneakers.com/app.php", {
            action: "create",
            price: Shopify.formatMoney(
                window.variantSel.compare_at_price &&
                    window.variantSel.compare_at_price < window.variantSel.price
                    ? window.variantSel.compare_at_price
                    : window.variantSel.price,
            ),
            cap: Shopify.formatMoney(
                window.variantSel && window.variantSel.compare_at_price
                    ? window.variantSel.compare_at_price
                    : "0,00",
            ),
            ori:
                window.variantSel && window.variantSel.featured_image
                    ? window.variantSel.featured_image.product_id
                    : "",
            sizes: window.sizes,
            descr: $(".product-single__meta .descr").html(),
            type: window.productType,
            model: nameOfShoe,
            loc: window.variantSel
                ? window.variantSel.title.split("/")[1]
                : $(".currency-switcher .current")
                      .html()
                      .replace(/<\/?[^>]+(>|$)/g, "")
                      .replace("&nbsp;", "")
                      .trim(),
            id: parseInt($(".pid").data("p-id")),
            size: window.variantSel
                ? window.variantSel.title.split("/")[0]
                : $(
                      ".customize-product-header-right #SingleOptionSelector-0",
                  ).val(),
            // setup: JSON.stringify($('#js-configurator').data('metafields')),
            image: imgUrl.replace("_120x", "_600x"),
            nftCustomValue: null,
            nftId: null,
            nftVariantSel: null,
            nftPrice: null,
            nftHash: null,
            nftSelectedFields: null,
            originalProductId: window.productId,
            countryCode: window.countryCode,
            possibleCountryMarkets: window.countries,
        })
            .done(function (id) {
                console.error(
                    "diverge-duplicate",
                    "new product created: " + id,
                );
                window.temporaryProductId = id;
            })
            .fail(function (data) {
                console.error("error", data);
                console.error("diverge-duplicate", "error: " + data);
            });
    });

    //if (preLoader !== undefined) preLoader.start();

    $(".js-button-add-to-cart-new-metafields").click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        gtag("event", "orderProduct", {
            shoe_name: $(".product-single__title").html(),
            origin: "productPage",
        });

        const init = {
            color: $(".button-customize-two").css("color"),
            font_size: $(".button-customize-two").css("font-size"),
            line_height: $(".button-customize-two").css("color"),
            element:
                "<span id='AddToCartText-product-template'>Add to cart</span>",
        };

        $(".button-customize-two").html('<i class="fa fa-spinner fa-spin"></i> Please wait');
        $(".button-customize-two").css("font-size", "15px");
        $(".button-customize-two").css("line-height", "19px");
        $(".button-customize-two").css("color", "black");
        $(".button-customize-two").attr("disabled", "disabled");

        if ($(window).innerWidth() >= 767) {
            imgUrl = $(
                $(".product-single__photo.default-image-cart img").get(0),
            ).attr("src");
        } else {
            //mobile - a primeira div do slider não serve
            //imgUrl = $($('.product-single__photo img').get(1)).attr('src');
            imgUrl = $(
                $(".product-single__photo.default-image-cart img").get(0),
            ).attr("src");
        }

        // console.error("imagUrl", imgUrl.replace("_120x", "_600x"));

        const addListenersToPopup = function () {
            setTimeout(() => {
                $(".mini__cart__product__img").on("click", function (e) {
                    $(".mini-cart-image-modal").show();
                    $("#mini-cart-image-popup-modal").attr(
                        "src",
                        e.currentTarget.src,
                    );
                    $("#mini-cart-popup-image-container").removeClass("custom");
                    $("#mini-cart-popup-image-container").removeClass(
                        "non-custom",
                    );

                    if ($(e.currentTarget).hasClass("custom")) {
                        $(".mini-cart-image-modal-container").addClass(
                            "custom",
                        );
                    } else if ($(e.currentTarget).hasClass("non-custom")) {
                        $(".mini-cart-image-modal-container").addClass(
                            "non-custom",
                        );
                    }
                });
            }, 1000);
        };
        
        CartJS.addItem(window.variantSel.id, 1, {}, {
            success: function(data, textStatus, jqXHR) {
                var myVar = document.getElementById("__st").innerHTML;
                if (myVar.includes("poltio") ){
                  console.log("Poltio received!");
                  CartJS.setAttribute('Poltio', true);
                }

                if (window.eventTag){
                  let event = window.eventTag.split("-")[1]
                  console.log("Setting event attribute:",event);
                  CartJS.setAttribute("Event",event);  
                }
                if ($(window).innerWidth() >= 767) {
                    $("#cart-drawer").toggleClass("active");
                    $("#mini-cart-overlay").toggleClass("active");
                    $(".button-customize-two").html(init.element);
                    $(".button-customize-two").css(
                        "font-size",
                        init.font_size,
                    );
                    $(".button-customize-two").css(
                        "line-height",
                        init.line_height,
                    );
                    $(".button-customize-two").css("color", init.color);
                    $(".button-customize-two").removeAttr("disabled");
                    addListenersToPopup();
                } else {
                    window.location.href = window.Shopify.routes.root + "cart";
                }
            },
            "error": function(jqXHR, textStatus, errorThrown) {
                console.error('Error: ' + errorThrown + '!');
            }
        });
    });

    $(".js-button-add-to-cart-old-metafields").click(function (e) {
        // alert("cliquei no button customize two");

        e.preventDefault();
        e.stopPropagation();

        gtag("event", "orderProduct", {
            shoe_name: $(".product-single__title").html(),
            origin: "productPage",
        });

        const init = {
            color: $(".button-customize-two").css("color"),
            font_size: $(".button-customize-two").css("font-size"),
            line_height: $(".button-customize-two").css("color"),
            element: "<span id='AddToCartText-product-template'>Add to cart</span>",
        };

        $(".button-customize-two").html('<i class="fa fa-spinner fa-spin"></i> Please wait');
        $(".button-customize-two").css("font-size", "15px");
        $(".button-customize-two").css("line-height", "19px");
        $(".button-customize-two").css("color", "black");
        $(".button-customize-two").attr("disabled", "disabled");

        if ($(window).innerWidth() >= 767) {
            imgUrl = $($(".product-single__photo.default-image-cart img").get(0)).attr("src");
        } else {
            //mobile - a primeira div do slider não serve
            //imgUrl = $($('.product-single__photo img').get(1)).attr('src');
            imgUrl = $($(".product-single__photo.default-image-cart img").get(0)).attr("src");
        }

        const mySteps = JSON.parse(localStorage.getItem("product_original"));
        if (obj) {
            try {
                obj = JSON.parse(obj);
            } catch (error) {}
        }

        (imgUrl = imgUrl.replace("_120x", "_600x")), preData();
        
        CartJS.addItem(window.variantSel.id, 1, {}, {
            success: function(data, textStatus, jqXHR) {
                if ($(window).innerWidth() >= 767) {
                    $("#cart-drawer").toggleClass("active");
                    $("#mini-cart-overlay").toggleClass("active");
                    $(".button-customize-two").html(init.element);
                    $(".button-customize-two").css(
                        "font-size",
                        init.font_size,
                    );
                    $(".button-customize-two").css(
                        "line-height",
                        init.line_height,
                    );
                    $(".button-customize-two").css("color", init.color);
                    $(".button-customize-two").removeAttr("disabled");
                    // addListenersToPopup();
                } else {
                    window.location.href = window.Shopify.routes.root + "cart";
                }
            },
            "error": function(jqXHR, textStatus, errorThrown) {
                console.error('Error: ' + errorThrown + '!');
            }
        });
    });

    $(".more-inf").click(function () {
        if ($(window).innerWidth() > 1400) {
            window.document.querySelector("#more").scrollIntoView({
                behavior: "smooth",
            });
        } else {
            window.document.querySelector(".inner-tabs").scrollIntoView({
                behavior: "smooth",
            });
        }
    });

    /*if( parseInt( $( '.product-item.grid__item.medium-up--one-half' ).length )
   && parseInt( $( '.product-item.grid__item.medium-up--one-half' ).length-1 ) % 2 == 0 ){
  var el = $( '.product-item.grid__item.medium-up--one-half' ).last().get(0);

  $( '[data-section-type="collection-template-section"]' ).append( $(el).clone() );

  var lEl = $( '.product-item.grid__item.medium-up--one-half' ).last();
  lEl.find( '.product-item__title' ).html("");
  lEl.find( '.customize__submit' ).remove();
  lEl.find( 'img' ).remove();
  lEl.css( 'background-color', '#d6d6d4' );
  lEl.find( '.product-item__link' ).removeAttr( 'href').css( 'cursor', 'default' );
}*/

    $(".symbol-input").keyup(function (e) {
        e.preventDefault();
        e.stopPropagation();

        var bN = $(e.target).val().split("\n");

        if ($(e.target).val().length > 11 && bN.length <= 1) {
            $(e.target).val($(e.target).val() + "\n");
        }
    });
    $($('[type="submit"]').get(1)).click(function (e) {
        if ($("#CreatePassword").val() != $("#CreatePassword2").val()) {
            e.preventDefault();
            e.stopPropagation();

            $("#CreatePassword").attr("style", "border: 1px solid red;");
            $("#CreatePassword2").attr("style", "border: 1px solid red;");

            return false;
        }
    });

    // TODO -> colocado aqui para o gift card não estava a reencaminhar para o carrinho
    // para além deste post foi alterado o theme.js const att linha 2100
    /*$("#AddToCart-product-template").click(function(){

    var id = $("#ProductSelect-product-template").val();
    var items = []
    items.push(id);
    
   $.post( "/cart/add.js", { quantity: 1, id: id },null,"json")


    .done(function( data,event ) {
      window.location.href = window.Shopify.routes.root + "cart"; 


    }).fail(function( data ,event) {

      console.log("erro ao adicionar ao cart");

    });

  });*/

    if ($(".size-selector-product").length) {
        setTimeout(function () {
            if (window.location.href.indexOf("variant=") === -1)
                $(".size-selector-product").change();
        }, 1000);
    }

    $("#btn_add_to_cart_gift_card").click(function () {
        var id = $("#SingleOptionSelector-giftCard").val();
        $.post("/cart/add.js", { quantity: 1, id: id }, null, "json");
        console.log("addded gift card 2");

        //location.href='https://www.diverge-sneakers.com/cart';

        setTimeout(function () {
            window.location.href = window.Shopify.routes.root + "cart";
        }, 500);
    });

    if ($(".size-selector-product").length) {
        setTimeout(function () {
            if (window.location.href.indexOf("variant=") === -1)
                $(".size-selector-product").change();
        }, 1000);
    }
});

$(document).ready(function () {
    $(".cart-image-container").on("click", function (e) {
        $(".image-modal").show();
        $("#image-popup-modal").attr("src", e.currentTarget.dataset.imageUrl);

        $("#popup-image-container").removeClass("my_landscape");
        if (
            (e.currentTarget.dataset.title &&
                e.currentTarget.dataset.title
                    .toLowerCase()
                    .includes("my landscape")) ||
            e.currentTarget.dataset.title.toLowerCase().includes("my now")
        ) {
            $("#popup-image-container").addClass("my_landscape");
        }

        $("#popup-image-container").removeClass("custom");
        $("#popup-image-container").removeClass("non-custom");

        console.error("debug-div", e.currentTarget.dataset);

        $("#popup-image-container").addClass(
            e.currentTarget.dataset.customProduct,
        );
    });
    $("#popup-image").on("click", function (e) {
        $(".image-modal").hide();
    });
    $("#popup-image-container").on("click", function (e) {
        e.stopPropagation();
    });
    $("#close-image-popup").on("click", function (e) {
        $(".image-modal").hide();
        e.stopPropagation();
    });

    $(".size-selector-product").change(function () {
        //console.log(".size-selector-product changed");
        var that = this;
        setTimeout(function () {
            if (window.allVar) {
                console.log("allVar");
                window.allVar.forEach(function (el, d) {
                    if (
                        el.title == $(that).val() ||
                        (el.option2 &&
                            $("#SingleOptionSelector-1").length &&
                            el.title ==
                                $(that).val() +
                                    " / " +
                                    $("#SingleOptionSelector-1").val())
                    ) {
                        window.variantSel = el;

                        $(".product-template__container").trigger({
                            type: "variantChange",
                            variant: window.variantSel,
                        });

                        if (
                            $(".price").length &&
                            $(".price").data("add") == "val"
                        ) {
                            $(".price").addClass("price--on-sale");
                        }
                        //if(typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") { mlvedaload(); }
                    }
                });
            }
        }, 200);
    });

    $(".custom-s-selector").change(function () {
        //console.log(".custom-s-selector changed");
        var that = this;
        if (window.allVar) {
            window.allVar.forEach(function (el, d) {
                if (
                    el.title == $(that).val() ||
                    (el.option2 &&
                        $("#SingleOptionSelector-1").length &&
                        el.title ==
                            $(that).val() +
                                " / " +
                                $("#SingleOptionSelector-1").val())
                ) {
                    window.variantSel = el;

                    $(".product-template__container").trigger({
                        type: "variantChange",
                        variant: window.variantSel,
                    });

                    if ($(".price").length && $(".price").data("add") == "val")
                        $(".price").addClass("price--on-sale");
                }
            });
        }
    });

    screen.lockOrientationUniversal =
        screen.lockOrientation ||
        screen.mozLockOrientation ||
        screen.msLockOrientation;

   

    $("body.template-product").css({ overflow: "auto" });
    //WHEN CLICK CBUTTON CUSTOMIZE PRODUCT

    let showLoader;

    $(".buy-now").click(function () {
        $(this).removeClass("buy-now");
        $(this).addClass("button-buy");
    });

    $(".button-buy").click(function (e) {
        e.preventDefault();
        //$(this).children().hide();
        $(this).css({ cursor: "none" });
    });

    $(".principal-controls ul").scroll(function () {
        if ($(this).scrollTop()) {
            $(".right-ic").css("border-right", "none");
        } else {
            $(".right-ic").css("border-right", "3px solid #bbbbbb");
        }
    });

    if (!window.variantSel) $(".size-selector-product").change();
});

function PrintDiv(el, dn) {
    if (html2canvas)
        html2canvas(document.querySelector(el)).then(function (canvas) {
            var myImage = canvas.toDataURL();

            //downloadURI(myImage, "diverge-symbol-simulation.png");

            setTimeout(function () {
                if (dn) dn(myImage);
            }, 100);
        });
}

function downloadURI(uri, name) {
    var link = document.createElement("a");

    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    //after creating link you should delete dynamic link
    //clearDynamicLink(link);
}
$(document).ready(function () {
    if (typeof DIVERGEVIEWER !== "undefined") {
        if (typeof protection !== "undefined") {
            if (protection != "E668AFD26A4808532E4704D55E405392") {
                DIVERGEVIEWER = null;
            }
        } else {
            DIVERGEVIEWER = null;
        }
    }
});
function renderSnapshotSymbol(el, color, cb) {
    $(".close-symbol-modal").css("display", "none");
    $(".symbol-notice").css("display", "none");
    $(".apply-symbol").css("display", "none");

    $(".symbol-modal")
        .css("width", "100px")
        .css("height", "100px")
        .css("background-image", "none")
        .css("background-color", "#000000")
        .css("left", "47%")
        .css("width", "256px")
        .css("height", "256px")
        .css("left", "44%");

    $(".symbol-words")
        .css("left", "95px")
        .css("width", "178px")
        .css("margin-top", "-55px")
        .css("background-color", "#000000");

    $(".symbol-words input").css("font-size", "40px");

    $("#first-word").css("width", "258px").css("font-size", "54px");

    $("#last-word").css("width", "258px").css("font-size", "54px");

    //set the color of text..
    $("#first-word").css("color", color);
    $("#last-word").css("color", color);

    PrintDiv(el, function (done) {
        //  $( '.close-symbol-modal' ).click();
        if (cb) cb(done);

        $(".symbol-modal").fadeOut();
    });
}

function revertSymbolDom(backgroundImage) {
    $(".close-symbol-modal").css("display", "inline-block");
    $(".symbol-notice").css("display", "block");
    $(".apply-symbol").css("display", "block");

    $(".symbol-modal")
        .css("width", "323px")
        .css("height", "340px")
        .css("background-image", backgroundImage)
        .css("background-color", "rgba(0,0,0,0.8)")
        .css("left", "42%");

    $("#first-word").css("width", "120px").css("font-size", "24px");

    $("#last-word").css("width", "120px").css("font-size", "24px");

    $(".symbol-words")
        .css("margin-top", "-48px")
        .css("left", "50%")
        .css("width", "114px")
        .css("background-color", "transparent");

    //set the color of text..
    $("#first-word").css("color", "#ffffff");
    $("#last-word").css("color", "#ffffff");

    $(".symbol-words").css("display", "block");
}

function getImgWords(fw) {
    var d = fw.split("\n");

    return (
        "https://3d.diverge-sneakers.com/text.image.php?first_word=" +
        (d[0] ? d[0] : "") +
        "&last_word=" +
        (d[1] ? d[1] : "") +
        "&model=" +
        window.productType
    );
}

$(document).ready(function () {
    

    //remove support loading image
    /*const removeSupport = setInterval(removeSupportImages, 500)
    function removeSupportImages () {
        if(window.innerWidth < 765) return
        // check if all images are ready 
        if(($('.FeaturedImage-product-template.lazyload').length == 0)) {
            console.log('running')
            setTimeout(() => {
                $('.to-hide-post-render').hide()
                $("html, body").animate({scrollTop:0}, 300)
                clearInterval(removeSupport)
            }, 500)
        }
    }

    //if it is a gift card we dont do any of this
    if($('.prod-large-img').attr('data-type') == 'Gift Card') return
    if($('.prod-large-img').attr('data-images') <= 1) return

    const updateMetaThumbnail = function () {
        //if there is no product-single__meta just return
        if(window.innerWidth < 765) return
        const $meta = $('.product-single__meta')
        const $thumbnails = $('.thumbnails-wrapper')
        const scrollValue = $(document).scrollTop()
        if($meta.length) {
            window.oldScreenSize = window.innerWidth
           
            if (($meta.offset().left + $meta.width() * 1.25)> window.innerWidth){
              $meta.css('left', 'none');
              $meta.css('right', '50px');
            } else{
              $meta.css('left', $meta.offset().left + 'px')
            }
          
            
            $meta.css('top', '135px')
            // $meta.css('left', $meta.offset().left + 'px')
            $meta.css('position', 'fixed')
        } else if($thumbnails.length && $thumbnails.is(':visible')) {
          
            $thumbnails.css('top', '155px')
            
            
            if (($meta.offset().left + $meta.width() * 1.25)> window.innerWidth){
              $meta.css('left', 'none');
              $meta.css('right', '50px');
            } else{
              $meta.css('left', $meta.offset().left + 'px')
              //$meta.css('left', $meta.offset().left + 100 + 'px')
            }

            $thumbnails.css('position', 'fixed')
            $('.product-single__photos').css('margin-left', '15%')
        } else {
            $('.product-single__photos').css('margin-left', '15%')
        }
      
      
        if(window.innerWidth < 1024 && window.innerWidth > 765) {
             $('.product-single__photos').css('margin-left', '15%')

             
             if (($meta.offset().left + $meta.width() * 1.25)> window.innerWidth){
              $meta.css('left', 'none');
              $meta.css('right', '50px');

            } else{
              $meta.css('left', $meta.offset().left + 100 + 'px')
            }
             
             // $meta.css('left', $meta.offset().left + 100 + 'px')
         }
    }
    const updateBasedOnLimits = function () {
        if(!$('.product-single__meta').length) return
        const scrollValue = $(document).scrollTop()
        const $product = $('.product-single')
        const productOffsetTop = $product.offset().top
        const productHeight = $product.height()
        const metaHeight = $('.product-single__meta').height()
        const product_meta_limit = productHeight + productOffsetTop - metaHeight - 150
        if(scrollValue >= product_meta_limit - 100) {
            $('.product-single__meta').css('top', product_meta_limit + 50)
            $('.product-single__meta').css('position', 'absolute')
        } else {
            $('.product-single__meta').css('top', '135px')
            $('.product-single__meta').css('position', 'fixed')
        }
        //if there is a thumbnail
        if($('.thumbnails-wrapper').length) {
            const thumbnailHeight = $('.thumbnails-wrapper').height()
            const thumbnail_meta_limit = productHeight + productOffsetTop - thumbnailHeight - 150
            if(scrollValue >= thumbnail_meta_limit - 100) {
                $('.thumbnails-wrapper').css('top', thumbnail_meta_limit + 50)
                $('.thumbnails-wrapper').css('position', 'absolute')
            } else {
                $('.thumbnails-wrapper').css('top', '135px')
                $('.thumbnails-wrapper').css('position', 'fixed')
            }
        }
    }

    const updateAspects = function () {
        if(window.innerWidth < 1024) {
            $('.product-single__photos').css('margin-left', '15%')
        }
        if(window.innerWidth < 1024 && window.innerWidth > 765) {
            $('.product-single__photos').css('margin-left', '15%')
            //update meta
            const scrollValue = $(document).scrollTop()
            const $product = $('.product-single')
            const productOffsetTop = $product.offset().top
            const productHeight = $product.height()
            const metaHeight = $('.product-single__meta').height()
            const product_meta_limit = productHeight + productOffsetTop - metaHeight - 150
            if(scrollValue >= product_meta_limit - 100) {
                $('.product-single__meta').css('top', product_meta_limit + 50)
                $('.produt-single__meta').css('left', '50%')
                $('.product-single__meta').css('position', 'absolute')
            } else {
                $('.product-single__meta').css('top', '135px')
                $('.product-single__meta').css('position', 'fixed')
            }
        }
        if(window.innerWidth > 1024) {
            $('.product-single__photos').css('margin-left', '15%')
        }
        if(window.innerWidth < 765) {
            $('.product-single__meta').css('position', 'unset')
        }
    }

    //make sure it only runs when the screen is ready
    const interval = setInterval(setup, 500)
    function setup() {
        //if it is mobile just leave
        if(window.innerWidth < 765) {
            clearInterval(interval)
            return
        }
        //check if all images are ready
        if(($('.FeaturedImage-product-template.lazyload').length == 0)) {
            setTimeout(() => {
                console.log('applying')
                updateMetaThumbnail()
                $(window).on('scroll', updateBasedOnLimits)
                $(window).on('resize', updateAspects)
                if(!$('.product-single__meta').length) return
                $("html, body").animate({scrollTop:0}, 300)
                clearInterval(interval)
            }, 500)
        }
    }*/

    // OLD VERSION
    /*setTimeout(() => {
         if(window.innerWidth < 765) return
         updateMetaThumbnail()
         $(window).on('scroll', updateBasedOnLimits)
         $(window).on('resize', updateAspects)
     }, 1500)
     const timeoutControl = setTimeout(() => {
         if(window.innerWidth < 765) return
         if(!$('.product-single__meta').length) return
         $("html, body").animate({scrollTop:0}, 300)
     }, 2000)*/

    var firstTimeScrollingFixed = true;
    var leftMarginAdjust = 0;
    var firstLoadFlag = true;

    setTimeout(function () {
        firstLoadFlag = false;
    }, 800);

    var viewport = document.getElementsByTagName("body")[0];

    var isProductPage =
        $(".product-template__container .product-single__photos").length > 0;

    window.scrollTo(0, 0);
    //$('body').addClass('stop-scrolling');

    //$("html, body").animate({ scrollTop: 0 }, 5000);
    //window.onscroll = function () { window.scrollTo(0, 0); };

    //$('.product-template__container .product-single__photos').css("width", "25%");

    function adjustProductScrolling() {
        //Não fazer scroll, caso apenas exista uma imagem
        if ($(".product-single__photo").length <= 1) {
            return;
        }

        const photosLeft = $(
            ".product-template__container .product-single__photos",
        ).offset();

        if (photosLeft !== undefined) {
            $(
                ".product-single__thumbnails.product-single__thumbnails-product-template .slick-list.draggable",
            ).css("height", "unset");

            var photosLeftPos = photosLeft.left;
            var photosWidth = $(
                ".product-template__container .product-single__photos",
            ).outerWidth(true);
            var photosRightPos = photosLeftPos + photosWidth;

            var bottomPhotos =
                $(
                    ".product-template__container .product-single__photos",
                ).offset().top +
                $(
                    ".product-template__container .product-single__photos",
                ).outerHeight(true);
            var scrollYAndThumbs =
                this.scrollY +
                $(
                    ".product-template__container .thumbnails-wrapper",
                ).outerHeight(true);
            var scrollYAndDesc =
                this.scrollY +
                $(".product-template__container .desc-prod").outerHeight(true);

            if (this.scrollY > 85) {
                /*console.log(photosLeftPos);
            console.log(photosWidth);
            console.log(photosRightPos);
            console.log("----");*/

                const windowWidth = window.innerWidth;

                if (windowWidth > 1024) {
                    $(
                        ".product-template__container .product-single__photos",
                    ).addClass("product-imgs-fixed");
                }

                if (scrollYAndDesc + 70 < bottomPhotos) {
                    $(".product-template__container .desc-prod").removeClass(
                        "product-desc-bottom",
                    );
                    $(".product-template__container .desc-prod").addClass(
                        "product-desc-fixed",
                    );

                    // console.log('photosRightPos', photosRightPos);
                    // console.log('leftMarginAdjust', leftMarginAdjust);

                    if (windowWidth > 1024) {
                        $(".product-template__container .desc-prod").css(
                            "left",
                            "calc(" +
                                (photosRightPos - leftMarginAdjust) +
                                "px)",
                        );
                    } else {
                        $(".product-template__container .desc-prod").css(
                            "left",
                            "calc(" + photosRightPos + "px)",
                        );
                    }
                    // $(".product-template__container .desc-prod").css('left', 'calc(' + (photosRightPos - leftMarginAdjust) + 'px)');

                    if (firstTimeScrollingFixed) {
                        firstTimeScrollingFixed = false;
                        leftMarginAdjust = 130;
                    }
                } else {
                    $(".product-template__container .desc-prod").css(
                        "left",
                        "unset",
                    );
                    $(".product-template__container .desc-prod").removeClass(
                        "product-desc-fixed",
                    );
                    $(".product-template__container .desc-prod").addClass(
                        "product-desc-bottom",
                    );
                    if (windowWidth > 1024) {
                        $(".product-template__container .desc-prod").css(
                            "left",
                            "calc(100% - 400px)",
                        );
                    } else {
                        $(".product-template__container .desc-prod").css(
                            "left",
                            "calc(" + photosRightPos + "px)",
                        );
                    }
                }

                //console.log('scrollYAndThumbs', scrollYAndThumbs);
                //console.log('bottomPhotos', bottomPhotos);

                if (scrollYAndThumbs + 70 < bottomPhotos) {
                    $(
                        ".product-template__container .thumbnails-wrapper",
                    ).removeClass("product-thumbnails-bottom");
                    $(
                        ".product-template__container .thumbnails-wrapper",
                    ).addClass("product-thumbnails-fixed");
                } else {
                    $(
                        ".product-template__container .thumbnails-wrapper",
                    ).removeClass("product-thumbnails-fixed");
                    $(
                        ".product-template__container .thumbnails-wrapper",
                    ).addClass("product-thumbnails-bottom");
                }
            } else {
                $(
                    ".product-template__container .thumbnails-wrapper",
                ).removeClass("product-thumbnails-fixed");
                $(
                    ".product-template__container .product-single__photos",
                ).removeClass("product-imgs-fixed");
                $(".product-template__container .desc-prod").removeClass(
                    "product-desc-fixed",
                );
                $(".product-template__container .desc-prod").css(
                    "left",
                    "unset",
                );

                firstTimeScrollingFixed = true;
                leftMarginAdjust = 0;
            }
        }

        //console.log('.thumbnails-wrapper', $('.thumbnails-wrapper .slick-list.draggable'))

        /*if(this.scrollY > 85){
          

            $(".product-template__container .product-single__photos").addClass("product-imgs-fixed");
          
            $('.thumbnails-wrapper .slick-list.draggable').css('height', 'unset');
          
          
            if((scrollYAndDesc ) < (bottomPhotos - 60)) {
                $(".product-template__container .desc-prod").removeClass("product-desc-bottom");
                $(".product-template__container .desc-prod").addClass("product-desc-fixed");
                $(".product-template__container .desc-prod").css('left', 'calc(' + (photosRightPos - leftMarginAdjust) + 'px)');
                
                if(firstTimeScrollingFixed){
                    firstTimeScrollingFixed = false;
                    leftMarginAdjust = 130;
                }
            } else {
                $(".product-template__container .desc-prod").css('left', 'unset');
                $(".product-template__container .desc-prod").removeClass("product-desc-fixed");
                $(".product-template__container .desc-prod").addClass("product-desc-bottom");
              
                $(".product-template__container .desc-prod").css('left', 'calc(57% + 56px)');
            }

            if((scrollYAndThumbs) <  (bottomPhotos - 75)) {
                $(".product-template__container .thumbnails-wrapper").removeClass("product-thumbnails-bottom");
                $(".product-template__container .thumbnails-wrapper").addClass("product-thumbnails-fixed");
            } else {
                $(".product-template__container .thumbnails-wrapper").removeClass("product-thumbnails-fixed");
                $(".product-template__container .thumbnails-wrapper").addClass("product-thumbnails-bottom");
            }
        } else{
            $(".product-template__container .thumbnails-wrapper").removeClass ("product-thumbnails-fixed");
            $(".product-template__container .product-single__photos").removeClass ("product-imgs-fixed");
            $(".product-template__container .desc-prod").removeClass ("product-desc-fixed");
            $(".product-template__container .desc-prod").css('left', 'unset');
          
            firstTimeScrollingFixed = true;
            leftMarginAdjust = 0;
        }*/
    }

    const firstPhotoHeight = $(
        $(
            ".product-template__container .product-single__photos .product-single__photo",
        )[0],
    ).height();
    const firstPhotoWidth = $(
        $(
            ".product-template__container .product-single__photos .product-single__photo",
        )[0],
    ).width();
    const firstPhotoRatio = firstPhotoWidth / firstPhotoHeight;

    adjustImageWidth();

    $(
        ".product-single .product-single .product-single__thumbnails .slick-list.draggable",
    ).css("height", "unset");

    function adjustImageWidth() {
        const windowHeight = $(window).height();
        const windowWidth = window.innerWidth;

        if (windowWidth > 765) {
            const percent = windowHeight / firstPhotoHeight;

            if (percent < 1) {
                //const calc = (100 * percent).toFixed(3);
                //if (lastWidth == -1 || Math.abs(lastWidth - calc) < 2){
                //$(".product-template__container .product-single__photos .prod-large-img").css('width', calc+'%');
                //$(".product-template__container").css("max-width", "800px");
                //lastWidth = calc;
                //}
                var newImageHeight = windowHeight - 70;
                var newImageWidth = newImageHeight * firstPhotoRatio;
                var newMaxWidth = 130 + newImageWidth + 400;
                $(".product-template__container").css(
                    "max-width",
                    newMaxWidth + "px",
                );
            } else {
                //$(".product-template__container .product-single__photos .prod-large-img").css('width', '100%');
                //$(".product-template__container").css("max-width", "1200px");
            }
        }
    }

    adjustArtist();
  

    function adjustArtist() {
        if (
            $(".second-description-text") &&
            $(".second-description-text").offset()
        ) {
            var leftImage = $(".second-description-text").offset().left;

            const windowWidth = window.innerWidth;

            const photosLeft = $(
                ".product-template__container .product-single__photos",
            ).offset();

            $(
                ".product-single__thumbnails.product-single__thumbnails-product-template .slick-list.draggable",
            ).css("height", "unset");

            var photosLeftPos = photosLeft.left;
            var photosWidth = $(
                ".product-template__container .product-single__photos",
            ).outerWidth(true);
            var photosRightPos = photosLeftPos + photosWidth;

            if (windowWidth > 1024) {
                $(".second-description-text").css("left", "calc(100% - 400px)");
            } else {
                $(".second-description-text").css(
                    "left",
                    "calc(" + (photosRightPos - 15) + "px)",
                );
            }

            leftImage -= 190;

            if (windowWidth < 1000) {
                $(".left-images").css("width", "100%");
                $(".left-images").css("padding", "40px 45px");

                $(".second-description-text").css("left", "unset");
                $(".second-description-text").css("position", "unset");
                $(".second-description-text").css("width", "100%");

                $(".second-description-text img").css("margin", "auto");
                $(".second-description-text").css("background", "#dadada");
                $(".second-description-text").css("margin-bottom", "20px");
                $(".second-description-text").css("padding-bottom", "40px");
            } else {
                $(".second-description-text").css("position", "absolute");
                $(".second-description-text").css("padding", "0");

                $(".second-description-text img").css("width", "400px");

                let thumbnailsWidth = $(
                    $(
                        ".product-template__container .product-single .thumbnails-wrapper",
                    )[0],
                ).width();
                if (thumbnailsWidth === 130) {
                    thumbnailsWidth = 0;
                }

                $(".left-images").css(
                    "width",
                    "calc(100% " + " - " + (530 - thumbnailsWidth - 10) + "px",
                );

                $(".custom-product-section").css(
                    "height",
                    $(".second-description-text img").height(),
                );
                $(".left-images").css(
                    "height",
                    $(".second-description-text img").height(),
                );

                $(".left-images").css("padding", "30px 45px");
            }

            if (windowWidth <= 1024) {
                if (windowWidth <= 766) {
                    $(".custom-product-section").css("margin", "0");
                } else {
                    $(".custom-product-section").css("margin", "0 7.5px");
                }
            }
        }

        // $(".left-images").css('padding', '35px');
    }

    window.addEventListener(
        "scroll",
        function (event) {
            if ($("#header").css("min-height") == "0px") {
                $("#mobile-nav-custom").css({
                    top: 89,
                });
            } else {
                $("#mobile-nav-custom").css({
                    top: 52,
                });
            }

            if (window.innerWidth < 767) {
                if ($(window).scrollTop() > 1000) {
                    $(".sticky-atc").css("opacity", "1");
                    $(".sticky-atc").css("display", "flex");
                } else {
                    $(".sticky-atc").css("opacity", "0");
                    $(".sticky-atc").css("display", "none");
                }
            }

            if (!firstLoadFlag && window.innerWidth > 767) {
                adjustProductScrolling();
            }

            if (firstLoadFlag && isProductPage) {
                window.scrollTo(0, 0);
            }
        },
        false,
    );

    window.addEventListener(
        "resize",
        function (event) {
            adjustProductScrolling();
            adjustImageWidth();

            adjustArtist();
            if (window.innerWidth > 768 && isProductPage) {
                window.scrollTo(0, 0);
            }

            $(".product-template__container .thumbnails-wrapper").removeClass(
                "product-thumbnails-fixed",
            );
            $(
                ".product-template__container .product-single__photos",
            ).removeClass("product-imgs-fixed");
            $(".product-template__container .desc-prod").removeClass(
                "product-desc-fixed",
            );
            $(".product-template__container .desc-prod").css("left", "unset");
            $(".product-template__container .desc-prod").removeClass(
                "product-desc-bottom",
            );
            $(".product-template__container .thumbnails-wrapper").removeClass(
                "product-thumbnails-bottom",
            );

            firstTimeScrollingFixed = true;
            leftMarginAdjust = 0;
        },
        false,
    );

    if ($(".mobile-nav ul")) {
        const firstChildUl = $($(".mobile-nav ul")[0]);
        $($(".mobile-nav ul")[0]).css("display", "block");
        const feature = $(firstChildUl).children()[0];
        $($(feature).find("ul")[0]).css("display", "block");

        const menu = $($(".mobile-nav li")[0]);
        $($("a i", $(menu))[0]).removeClass("ad-plus-l");
        $($("a i", $(menu))[0]).addClass("ad-minus-l");

        const a = $($(feature).find("a")[0]);
        const iconA = $("i", $(a));
        $(iconA).removeClass("ad-plus-l");
        $(iconA).addClass("ad-minus-l");
    }

    $(".mini-products-list a.product-image").click(function (e) {
        console.log("click");
        e.stopPropagation();
        e.preventDefault();
    });

    $(".mini-products-list a.pName").click(function (e) {
        console.log("click");
        e.stopPropagation();
        e.preventDefault();
    });
});

function formatNftHash(nftHash) {
    var hash = nftHash;

    //Replace - with _ because some colors have this char
    hash = hash.replaceAll("-", "_");

    // console.error("hash_");
    // console.error(hash);

    //Need to remove all colors from the hash since we already have the hex value
    //Get every color between ; and /#
    var formatedHash1 = "";
    if (hash !== undefined && hash.match(/\:\w*\/#/g) !== null) {
        formatedHash1 = hash.match(/\:\w*\/#/g).map(function (str) {
            return str.slice(1, -2);
        });
    }
    //var formatedHash1 = hash.match(/\:.*\/#/g).map(function(str){return str.slice(1,-2)})
    //Get every color between , and /#
    var formatedHash2 = "";
    if (hash !== undefined && hash.match(/\,\w*\/#/g) !== null) {
        formatedHash2 = hash.match(/\,\w*\/#/g).map(function (str) {
            return str.slice(1, -2);
        });
    }
    //var formatedHash2 = hash.match(/\,.*\/#/g).map(function(str){return str.slice(1,-2)})

    var allColors = formatedHash1.concat(formatedHash2);

    //console.error("allColors");
    //console.error(allColors);

    //Remove duplicated
    var uniqueColors = [];
    $.each(allColors, function (i, el) {
        if ($.inArray(el, uniqueColors) === -1) uniqueColors.push(el);
    });

    //order from biggest string to lowest, so it doesn't mess up the replace
    // => In case "off_white" and "white" exist, "off_white" needs to be replaced first or we end up with a "off_" color.
    uniqueColors = uniqueColors.sort((a, b) => b.length - a.length);

    //console.error("uniqueColors");
    //console.error(uniqueColors);

    //Remove all colors from the object hash
    uniqueColors.forEach(function (color) {
        hash = hash.replaceAll(color, "");
    });

    //console.error("hash");
    //console.error(hash);

    //Necessary because tab "Acessories" adds ; after some colors
    hash = hash.replaceAll(";", "");

    //console.error("hash2");
    //console.error(hash);

    const hashObj = JSON.parse(hash);
    //var jsonObj = JSON.parse(nftHash);

    var hashDict = {};

    for (const [key, value] of Object.entries(hashObj)) {
        var hashStepDict = {};
        for (const [stepKey, stepValue] of Object.entries(value)) {
            if (stepKey.toLowerCase().includes("selected")) {
                hashStepDict[stepKey] = stepValue;
                //console.error(key+" -> "+stepKey+": "+stepValue);
            }
        }
        if (key != "step9") {
            hashDict[key] = hashStepDict;
        }
    }

    hashDict["name"] = window.productType;

    //console.error("----------");

    //console.error(hashDict);

    //console.error("hash formatNftHash1: "+JSON.stringify(hashDict));
    //console.error("hash formatNftHash2: "+hash);

    //return hash;
    return JSON.stringify(hashDict);
}

function setupNftModal() {
    let hashes = [];

    if (window.originalNFT != null) {
        hashes = window.originalNFT["nftHashes"].split(",");
    }

    console.log("Existing hashes: " + hashes);

    if (hashes.includes(window.nftHash)) {
        console.log("ntf already exists");
        $("#nft-notready").show();
        $("#nft-checkbox").hide();
        $("#nft-notready h1").text(
            "A NFT featuring this colour combination already exists. Please change a colour or material and try again.",
        );
    } else if (window.nftHash == window.originalHash) {
        console.log("ntf already exists");
        $("#nft-notready").show();
        $("#nft-checkbox").hide();
        $("#nft-notready h1").text(
            "Minting a NFT from an existing colour way is not possible. Please customize the sneaker to create a unique colour combination.",
        );
    } else {
        console.log("ntf not exists");
        $("#nft-notready").hide();
        $("#nft-checkbox").show();
    }
}

rivets.formatters.search = function (value, args) {
    return String(value).includes(args);
};

$(function () {
    setTimeout(() => {
        $(".mini__cart__product__img").on("click", function (e) {
            $(".mini-cart-image-modal").show();

            $("#mini-cart-popup-image-container").removeClass("my_landscape");
            if (
                e.currentTarget.alt.toLowerCase().includes("my landscape") ||
                e.currentTarget.alt.toLowerCase().includes("my now")
            ) {
                $("#mini-cart-popup-image-container").addClass("my_landscape");
            }

            $("#mini-cart-image-popup-modal").attr("src", e.currentTarget.src);
            $("#mini-cart-popup-image-container").removeClass("custom");
            $("#mini-cart-popup-image-container").removeClass("non-custom");

            if ($(e.currentTarget).hasClass("custom")) {
                $(".mini-cart-image-modal-container").addClass("custom");
            } else if ($(e.currentTarget).hasClass("non-custom")) {
                $(".mini-cart-image-modal-container").addClass("non-custom");
            }
        });
        $("#mini-cart-popup-image").on("click", function (e) {
            $(".mini-cart-image-modal").hide();
        });
        $("#mini-cart-popup-image-container").on("click", function (e) {
            e.stopPropagation();
        });
        $("#mini-cart-close-image-popup").on("click", function (e) {
            $(".mini-cart-image-modal").hide();
            e.stopPropagation();
        });
    }, 500);
});
